// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-settings-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.notifications-settings-page .settings-modal-header {
  position: relative;
  justify-content: center;
}

.notifications-settings-page .back-button {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.notifications-settings-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.notifications-section {
  margin-bottom: 32px;
}

.notifications-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

/* Permission Status Boxes */
.notification-status-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.notification-status-box ion-icon {
  font-size: 32px;
}

.notification-status-box.warning {
  background-color: #fff8e1;
  border: 1px solid #ffc107;
}

.notification-status-box.warning ion-icon {
  color: #ff9800;
}

.notification-status-box.info {
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
}

.notification-status-box.info ion-icon {
  color: #2196f3;
}

.notification-status-box.success {
  background-color: #e8f5e9;
  border: 1px solid #4caf50;
}

.notification-status-box.success ion-icon {
  color: #4caf50;
}

.status-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.status-description {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* Browser-specific instructions for blocked notifications */
.browser-instructions {
  text-align: left;
  margin: 12px 0 0 0;
  padding-left: 24px;
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}

.browser-instructions li {
  margin-bottom: 8px;
}

.browser-instructions li:last-child {
  margin-bottom: 0;
}

.enable-notifications-button {
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background-color: var(--netsfere-red);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-top: 8px;
}

.enable-notifications-button:hover {
  background-color: #b82419;
}

/* Notification Toggles */
.notifications-toggles {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.notifications-sub-toggles {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 49px;
  border-left: 2px solid #e0e0e0;
  margin-left: 10px;
}

/* Disabled toggle styling */
.notifications-sub-toggles .settings-toggle-container.disabled {
  opacity: 0.5;
}

.notifications-sub-toggles .settings-toggle-container.disabled .settings-toggle-label,
.notifications-sub-toggles .settings-toggle-container.disabled .settings-toggle-description {
  color: #999;
}

/* Test Notification Section */
.test-notification-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.test-description {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.test-notification-button {
  align-self: flex-start;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background-color: var(--netsfere-red);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.test-notification-button:hover:not(:disabled) {
  background-color: #b82419;
}

.test-notification-button:disabled {
  background-color: #ed9a9a;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .notifications-settings-content {
    padding: 16px;
  }

  .notifications-sub-toggles {
    padding-left: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/NotificationsSettingsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".notifications-settings-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.notifications-settings-page .settings-modal-header {\n  position: relative;\n  justify-content: center;\n}\n\n.notifications-settings-page .back-button {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.notifications-settings-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.notifications-section {\n  margin-bottom: 32px;\n}\n\n.notifications-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n/* Permission Status Boxes */\n.notification-status-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 20px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.notification-status-box ion-icon {\n  font-size: 32px;\n}\n\n.notification-status-box.warning {\n  background-color: #fff8e1;\n  border: 1px solid #ffc107;\n}\n\n.notification-status-box.warning ion-icon {\n  color: #ff9800;\n}\n\n.notification-status-box.info {\n  background-color: #e3f2fd;\n  border: 1px solid #2196f3;\n}\n\n.notification-status-box.info ion-icon {\n  color: #2196f3;\n}\n\n.notification-status-box.success {\n  background-color: #e8f5e9;\n  border: 1px solid #4caf50;\n}\n\n.notification-status-box.success ion-icon {\n  color: #4caf50;\n}\n\n.status-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.status-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.status-description {\n  font-size: 14px;\n  color: #666;\n  line-height: 1.4;\n}\n\n/* Browser-specific instructions for blocked notifications */\n.browser-instructions {\n  text-align: left;\n  margin: 12px 0 0 0;\n  padding-left: 24px;\n  font-size: 14px;\n  color: #555;\n  line-height: 1.6;\n}\n\n.browser-instructions li {\n  margin-bottom: 8px;\n}\n\n.browser-instructions li:last-child {\n  margin-bottom: 0;\n}\n\n.enable-notifications-button {\n  padding: 12px 24px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  background-color: var(--netsfere-red);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  margin-top: 8px;\n}\n\n.enable-notifications-button:hover {\n  background-color: #b82419;\n}\n\n/* Notification Toggles */\n.notifications-toggles {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.notifications-sub-toggles {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-left: 49px;\n  border-left: 2px solid #e0e0e0;\n  margin-left: 10px;\n}\n\n/* Disabled toggle styling */\n.notifications-sub-toggles .settings-toggle-container.disabled {\n  opacity: 0.5;\n}\n\n.notifications-sub-toggles .settings-toggle-container.disabled .settings-toggle-label,\n.notifications-sub-toggles .settings-toggle-container.disabled .settings-toggle-description {\n  color: #999;\n}\n\n/* Test Notification Section */\n.test-notification-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.test-description {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.5;\n}\n\n.test-notification-button {\n  align-self: flex-start;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  background-color: var(--netsfere-red);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.test-notification-button:hover:not(:disabled) {\n  background-color: #b82419;\n}\n\n.test-notification-button:disabled {\n  background-color: #ed9a9a;\n  cursor: not-allowed;\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .notifications-settings-content {\n    padding: 16px;\n  }\n\n  .notifications-sub-toggles {\n    padding-left: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
